(function () {
  'use strict';

  angular.module('app').service('GuestModalService', GuestModalService);

  GuestModalService.$inject = ['ModalService'];

  function GuestModalService(ModalService) {
    var service = {
      openBookingGuestDetailModal: openBookingGuestDetailModal,
    };

    return service;

    //////////////

    function openBookingGuestDetailModal(guest, booking, mode, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/booking-guests/modals/guest-detail-modal.html',
        controller: BookingGuestDetaiModalCtrl,
        controllerAs: 'vm',
        inputs: {
          guest: guest,
          booking: booking,
          mode: mode,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      BookingGuestDetaiModalCtrl.$inject = [
        '$element',
        'UtilService',
        'guest',
        'booking',
        'mode',
        'successCallback',
      ];
    }

    function BookingGuestDetaiModalCtrl(
      $element,
      UtilService,
      guest,
      booking,
      mode,
      successCallback
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.guest = guest;
      vm.booking = booking;
      vm.mode = mode;

      vm.modalTitle = guest.id ? 'GUEST_DETAILS' : 'NEW_GUEST';

      vm.onBookingGuestSaved = onBookingGuestSaved;
      vm.onBookingGuestCanceled = onBookingGuestCanceled;

      function onBookingGuestSaved(data) {
        $element.modal('hide');
        successCallback(data);
      }

      function onBookingGuestCanceled() {
        $element.modal('hide');
      }
    }
  }
})();
